exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper-container[data-v-2078095a]{height:100vh;width:100%}.slide-img[data-v-2078095a]{width:100%;height:auto}.swiper-button-prev[data-v-2078095a]{background-image:none;left:0;width:50vw;height:100vh;top:0}.swiper-button-next[data-v-2078095a]{background-image:none;right:0;width:50vw;height:100vh;top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2078095a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Home.vue
// module id = 950
// module chunks = 0